/**
 * 计算数字人位置
 * @param digitalmanData
 * @returns
 */
export const getVideoParamByPosition = (digitalmanData) => {
  const { width: anchorWidth, height: anchorHeight, left: x, top: y, scaleX, originZoomStr } = digitalmanData;
  // 采用 resolution 作为基准
  let [containerWidth, wrapperHeight] = digitalmanData.resolution.split('x');
  containerWidth = parseInt(containerWidth);
  wrapperHeight = parseInt(wrapperHeight);
  // horizontalPosition = (x + anchorWidth / 2 - containerWidth / 2) / containerWidth
  const horizontalPosition = (x + anchorWidth / 2 - containerWidth / 2) / containerWidth;
  // verticalPosition = (anchorHeight + y - wrapperHeight) / 2 / anchorHeight
  const verticalPosition = (anchorHeight + y - wrapperHeight) / 2 / anchorHeight;
  // 等比例缩放，直接采用 scaleX
  const scale = scaleX / parseFloat(originZoomStr);

  // 最后算一下left、top、scale的百分比作为回显的办法

  return { horizontalPosition, verticalPosition, scale, x, y, height: anchorHeight, width: anchorWidth };
};
